import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PathList from "../Common/PathList";

function PrivateRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    try
    {
      const userInfo = JSON.parse(localStorage.getItem("cateringFiestaInfo"));
      if (userInfo)
      {
        setIsAuthenticated(true);
        // navigate(PathList._Dashboard);
      } else
      {
        navigate(PathList._Login);
      }
    } catch (error)
    {
      navigate(PathList._Login);
    } finally
    {
      setIsLoading(false);
    }
  }, [navigate]);

  if (isLoading)
  {
    return null;
    // return children;
  }


  return isAuthenticated ? children : null;
  // return isAuthenticated ? children : children;
}

export default PrivateRoute;
